type IconProps = {
  color?: string;
  size?: number;
  className?: string;
};

export function IconX({
  color = "currentColor",
  size = 20,
  className,
}: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.3332 15.5449L4.45508 14.6668L9.12174 10.0001L4.45508 5.33345L5.3332 4.45532L9.99987 9.12199L14.6665 4.45532L15.5447 5.33345L10.878 10.0001L15.5447 14.6668L14.6665 15.5449L9.99987 10.8782L5.3332 15.5449Z"
        fill="currentColor"
      />
    </svg>
  );
}
